"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var AbovePromotion_1 = require("./AbovePromotion");

var AverageMargin_1 = require("./AverageMargin");

var ListingPriceProtection_1 = require("./ListingPriceProtection");

var Margin_1 = require("./Margin");

var PriceChange_1 = require("./PriceChange");

var PromoProtection_1 = require("./PromoProtection");

var RepricingFrequency_1 = require("./RepricingFrequency");

var WeekDayRestriction_1 = require("./WeekDayRestriction");
/**
 * Encapsulates {@link Constraint constraint} settings.
 *
 * @author RV
 */


var ConstraintSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ConstraintSettings, _DomainObject_1$Domai);

  /**
   *
   * @param constraints
   */
  function ConstraintSettings(constraints) {
    var _this;

    _classCallCheck(this, ConstraintSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConstraintSettings).call(this));
    _this.constraints = constraints;
    return _this;
  }

  _createClass(ConstraintSettings, [{
    key: "areEmptySettings",
    value: function areEmptySettings() {
      return this.constraints.isEmpty();
    }
    /**
     * Returns Constraints that are not present or are not same as in provided resolved constraint settings
     *
     * @param resolvedConstraintSettings
     * @returns list of constraints that were not in resolved settings
     */

  }, {
    key: "diffConstraintsWithResolvent",
    value: function diffConstraintsWithResolvent(resolvedConstraintSettings) {
      var _this2 = this;

      if (!resolvedConstraintSettings) {
        return this;
      }

      return this.copy('constraints', this.constraints.filter(function (item) {
        var constraint = resolvedConstraintSettings.constraints.find(function (i) {
          return i.getType() === item.getType();
        }); // does not exist in resolved settings

        if (!constraint) {
          return true;
        }

        return !_this2.compareConstraints(item, constraint);
      }));
    }
    /**
     * Compares constraints of same type.
     *
     * @param constraint
     * @param otherConstraint
     * @return true constraints are same, false otherwise
     */

  }, {
    key: "compareConstraints",
    value: function compareConstraints(constraint, otherConstraint) {
      if (constraint.getType() !== otherConstraint.getType()) {
        return false;
      }

      if (constraint instanceof Margin_1.Margin && otherConstraint instanceof Margin_1.Margin || constraint instanceof PriceChange_1.PriceChange && otherConstraint instanceof PriceChange_1.PriceChange) {
        return constraint.range.maximum.equals(otherConstraint.range.maximum) && constraint.range.minimum.equals(otherConstraint.range.minimum);
      }

      if (constraint instanceof AverageMargin_1.AverageMargin && otherConstraint instanceof AverageMargin_1.AverageMargin || constraint instanceof AbovePromotion_1.AbovePromotion && otherConstraint instanceof AbovePromotion_1.AbovePromotion || constraint instanceof ListingPriceProtection_1.ListingPriceProtection && otherConstraint instanceof ListingPriceProtection_1.ListingPriceProtection || constraint instanceof PromoProtection_1.PromoProtection && otherConstraint instanceof PromoProtection_1.PromoProtection || constraint instanceof RepricingFrequency_1.RepricingFrequency && otherConstraint instanceof RepricingFrequency_1.RepricingFrequency) {
        return constraint.value.equals(otherConstraint.value);
      }

      if (constraint instanceof WeekDayRestriction_1.WeekDayRestriction && otherConstraint instanceof WeekDayRestriction_1.WeekDayRestriction) {
        return constraint.days.equals(otherConstraint.days);
      }

      throw new Error("Illegal argument exception for given types ".concat(constraint.getType(), " and ").concat(otherConstraint.getType()));
    }
  }]);

  return ConstraintSettings;
}(DomainObject_1.DomainObject);

exports.ConstraintSettings = ConstraintSettings;

ConstraintSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder();
  return {
    constraints: builder.listOf(builder.lookup('constraints', 'enums/constraintTypes'))
  };
}();